import { useState } from "react";
import { CSVStudent as BaseCSVStudent } from "../../../utils/csv/csv-validatorStudent";

export interface CSVStudent extends BaseCSVStudent {
  name: string;
  email: string;
  isValid: boolean;
  error?: string;
}

export function useCSVStudentData() {
  const [selectedFile, setSelectedFile] = useState<File | null>(null);
  const [CSVStudentError, setCSVStudentError] = useState<string | null>(null);
  const [CSVStudentPreviewData, setCSVStudentPreviewData] = useState<
    CSVStudent[]
  >([]);
  const [invalidData, setInvalidData] = useState<CSVStudent[]>([]);
  const [fileInputKey, setFileInputKey] = useState(Date.now());

  const isValidEmail = (email: string): boolean => {
    const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return regex.test(email);
  };

  const isValidName = (name: string): boolean => {
    return name.length >= 3;
  };

  // Function to validate a student
  function validateStudent(student: CSVStudent): CSVStudent {
    let isValid = true;
    let error = "";

    if (!isValidName(student.name)) {
      isValid = false;
      error += "Nome inválido. ";
    }

    if (!isValidEmail(student.email)) {
      isValid = false;
      error += "Email inválido.";
    }

    return {
      ...student,
      isValid,
      error: isValid ? undefined : error,
    };
  }

  // Function to handle CSV file upload and validation
  const handleCSVStudentFileUpload = async (file: File) => {
    setSelectedFile(file);
    if (file) {
      try {
        const text = await file.text();
        const rows = text
          .split("\n")
          .map((row: string) =>
            row.split(",").map((cell: string) => cell.trim())
          )
          .filter((row) => row.length === 2 && row[0] && row[1]);

        const validStudents: CSVStudent[] = [];
        const invalidStudents: CSVStudent[] = [];

        rows.forEach((row) => {
          const name = row[0];
          const email = row[1];
          const student = validateStudent({ name, email, isValid: true });

          if (student.isValid) {
            validStudents.push(student);
          } else {
            invalidStudents.push(student);
          }
        });

        setCSVStudentError(null);
        setCSVStudentPreviewData(validStudents);
        setInvalidData(invalidStudents);
      } catch (error) {
        setCSVStudentError(
          error instanceof Error ? error.message : "Erro ao ler o arquivo."
        );
      }
    }
  };

  return {
    selectedFile,
    setSelectedFile,
    CSVStudentError,
    CSVStudentPreviewData,
    invalidData,
    fileInputKey,
    setFileInputKey,
    validateStudent,
    handleCSVStudentFileUpload,
    setCSVStudentError,
    setCSVStudentPreviewData,
    setInvalidData,
  };
}
